import PriceInputs from "../../liquidity/PriceInputs"
import styles from "./RepositionPriceInputs.module.css"

const RepositionPriceInputs = () => {
    return (
        <div className={styles.price_inputs_container}>
            <span className={styles.title}>Position Width</span>
               <div className={styles.price_display}>
          <span className={styles.price_title}>Current Price</span>
          <span className={styles.current_price}>$2,658.00</span>
        </div>
            
      <div className={styles.price_inputs_content}>
          
          <PriceInputs title="Min Price" field_id="reposition-min-price" percentageDifference={-15}/>
          <PriceInputs title="Max Price" field_id="reposition-max-price" percentageDifference={15}/>
    </div>
      </div>
  )
}

export default RepositionPriceInputs